import React, { useMemo } from "react";
import { Tabs } from "../../Tabs/Tabs";
import { BuildCard } from "../../BuildCard/BuildCard";
import { useTabsLogic } from "@profile/pages/MembershipPage/hooks/useTabsLogis";
import { ProtectCard } from "../../ProtectCard/ProtectCard";

import ethImage from "./images/eth.png";
import btcImage from "./images/btc.png";
import usdtImage from "./images/usdt.png";
import robinhoodImage from "./images/robinhood.png";
import coinbaseImage from "./images/coinbase.png";
import exodusImage from "./images/exodus.png";
import circleImage from "./images/circle.png";
import krakenImage from "./images/kraken.png";
import bitfinexImage from "./images/bitfinex.png";
import ethStake1 from "./images/ethStake1.png";
import ethStake2 from "./images/ethStake2.png";
import ethStake3 from "./images/ethStake3.png";
import convertEur from "./images/convertEur.png";
import convertUsd from "./images/convertUsd.png";
import convertGbp from "./images/convertGbp.png";
import btcFinancialPlan from "./images/btcFinancialPlan.png";
import btcTaxTechnology from "./images/btcTaxTechnology.png";
import btcInheritaneTechnology from "./images/btcInheritaneTechnology.png";
import { useMembershipPageContext } from "@profile/pages/MembershipPage/MembershipPage.context";
import { rootUrl } from "@bundles/consts";

const getBuildCardsData = (slug?: string) => [
  {
    imageSrc1: ethImage,
    imageSrc2: btcImage,
    imageSrc3: usdtImage,
    title: "Buy Bitcoin & Stake ETH",
    features: [
      "Buy, sell & custody Bitcoin",
      "Stake ETH & earn weekly income in Bitcoin, ETH, USDT or USD",
      "Convert your local fiat currency (USD, GBP, EUR etc.) to Stablecoin like USDT to dollar cost average into Bitcoin",
    ],
    buttonText: "View investments",
    buttonLink: `${rootUrl}/profile/${slug}/funds`,
    disclaimer:
      "To buy bitcoin, stablecoins & stake ETH, you need at least a Tier 1 account.",
    disclaimerReadMoreOnclick: () => {
      document
        .getElementById("investor-accounts-secion-tabs")
        ?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    imageSrc1: robinhoodImage,
    imageSrc2: coinbaseImage,
    imageSrc3: exodusImage,
    title: "Invest in Bitcoin Mining & Public Shares",
    features: [
      "Buy, sell & custody bitcoin mining stocks",
      "Buy, sell & custody bitcoin public shares",
      "Buy, sell & custody bitcoin exchange traded funds (ETFs) & mutual funds",
    ],
    buttonText: "View investments",
    buttonLink: `${rootUrl}/profile/${slug}/shares/public-equity`,
    disclaimer:
      "To invest in Bitcoin Mining & Public Shares, you need at least a Tier 2 account.",
    disclaimerReadMoreOnclick: () => {
      document
        .getElementById("investor-accounts-secion-tabs")
        ?.scrollIntoView({ behavior: "smooth" });
    },
  },
  {
    imageSrc1: circleImage,
    imageSrc2: krakenImage,
    imageSrc3: bitfinexImage,
    title: "Invest in Bitcoin Private Equity",
    features: [
      "Invest in new Bitcoin Startups",
      "Buy & Sell Shares in Private Bitcoin companies",
      "Invest in security tokens and other security offerings",
    ],
    buttonText: "View investments",
    buttonLink: "/market",
    disclaimer:
      "To invest in Bitcoin Private Equity, you need a Tier 4 account.",
    disclaimerReadMoreOnclick: () => {
      document
        .getElementById("investor-accounts-secion-tabs")
        ?.scrollIntoView({ behavior: "smooth" });
    },
  },
];

const getUkBuildCardsData = (slug?: string, timelockMinValue?: number) => [
  {
    imageSrc1: ethImage,
    imageSrc2: btcImage,
    imageSrc3: usdtImage,
    title: "Buy Bitcoin",
    features: ["Buy, sell & custody Bitcoin."],
    buttonText: "Buy Now",
    buttonLink: `${rootUrl}/profile/${slug}/funds/manage/buy?currency=btc`,
    disclaimer:
      "To buy bitcoin, stablecoins & stake ETH, you need at least a Tier 1 account.",
    disclaimerReadMoreOnclick: undefined,
  },
  {
    imageSrc1: ethStake1,
    imageSrc2: ethStake2,
    imageSrc3: ethStake3,
    title: "Stake ETH",
    features: ["Stake ETH & earn weekly income in Bitcoin, ETH, USDT or USD."],
    buttonText: "Stake Now",
    buttonLink: `${rootUrl}/profile/${slug}/funds/stakingEth`,
    disclaimer:
      "To buy bitcoin, stablecoins & stake ETH, you need at least a Tier 1 account.",
    disclaimerReadMoreOnclick: undefined,
  },
  {
    imageSrc1: convertEur,
    imageSrc2: convertUsd,
    imageSrc3: convertGbp,
    title: "Convert Fiat To Stablecoins",
    features: [
      "Convert your local fiat currency (USD, GBP, EUR etc.) to Stablecoin like USDT to dollar cost average into Bitcoin.",
    ],
    buttonText: "Convert Now",
    buttonLink: `${rootUrl}/profile/${slug}/funds/manage/deposit?currency=bfusd`,
    disclaimer:
      "To buy bitcoin, stablecoins & stake ETH, you need at least a Tier 1 account.",
    disclaimerReadMoreOnclick: undefined,
  },
];

const getProtectCardsData = (isUk?: boolean) => [
  {
    overlayText: "bitcoin financial planning",
    imageSrc: btcFinancialPlan,
    description: (
      <>
        <p className="mb-3">
          To help you&nbsp;{isUk ? "manage" : "protect"}&nbsp;your Bitcoin
          Wealth, we’ve partnered with the Bitcoin Wealth Builder Program
          (valued at $5,000), a 7-module online program that includes a specific
          module related to helping you prepare a Bitcoin Wealth Builder
          Financial and Protection Plan.
        </p>
        <p>
          Bnk To The Future investors that meet a minimum investment threshold
          get access to the program{isUk ? "" : " for FREE"}.
        </p>
      </>
    ),
    disclaimer:
      'By clicking "Full Details", you will be redirected to a partner website where you can find information about the Bitcoin Wealth Builder Program',
  },
  {
    overlayText: "BITCOIN TAX TECHNOLOGY",
    imageSrc: btcTaxTechnology,
    description: (
      <>
        <p className="mb-3">
          To help you prepare a Bitcoin Tax Technology Plan, we’ve partnered
          with the Bitcoin Wealth Builder Program (valued at $5,000), a 7-module
          online program that includes a specific module related to using
          Bitcoin Tax Technology.
        </p>
        <p>
          Bnk To The Future investors that meet a minimum investment threshold
          get access to the program{isUk ? "" : " for FREE"}.
        </p>
      </>
    ),
    disclaimer:
      'By clicking "Full Details", you will be redirected to a partner website where you can find information about the Bitcoin Wealth Builder Program',
  },
  {
    overlayText: "BITCOIN INHERITANCE TECHNOLOGY",
    imageSrc: btcInheritaneTechnology,
    description: (
      <>
        <p className="mb-3">
          To help you prepare a Bitcoin inheritance technology plan, we’ve
          partnered with the Bitcoin Wealth Builder Program (valued at $5,000),
          a 7-module online program that includes a specific module using
          Bitcoin inheritance technology.
        </p>
        <p>
          Bnk To The Future investors that meet a minimum investment threshold
          get access to the program{isUk ? "" : " for FREE"}.
        </p>
      </>
    ),
    disclaimer:
      'By clicking "Full Details", you will be redirected to a partner website where you can find information about the Bitcoin Wealth Builder Program',
  },
];

type BuildBitcoinWealthProps = {
  slug?: string;
  isUk?: boolean;
  bitcoinJourneyStep: number;
};

export const BuildBitcoinWealth = ({
  slug,
  isUk,
  bitcoinJourneyStep,
}: BuildBitcoinWealthProps) => {
  const tabsOptions = useMemo(
    () => [
      {
        label: "Build",
        value: "build",
      },
      {
        label: isUk ? "Manage" : "Protect",
        value: "protect",
      },
    ],
    [isUk]
  );

  const { activeTab, handleChangeActiveTab } = useTabsLogic(tabsOptions);

  const isStep3Completed = bitcoinJourneyStep >= 3;

  const buildCardsData = isUk
    ? getUkBuildCardsData(slug)
    : getBuildCardsData(slug);

  const protectCardsData = getProtectCardsData(isUk);

  return (
    <div>
      <h4 className="text-center mx-auto mb-7">
        {isUk
          ? "Build and Manage Your Bitcoin Wealth"
          : "Build and Protect Your Bitcoin Wealth"}
      </h4>

      <div className="mb-[40px] md:mb-[60px]" id="services-section-tabs">
        <Tabs
          options={tabsOptions}
          activeValue={activeTab}
          onChange={handleChangeActiveTab}
        />
      </div>

      {activeTab === "build" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mx-auto p-4 pb-0">
          {buildCardsData.map((card, index) => (
            <BuildCard
              key={index}
              imageSrc1={card.imageSrc1}
              imageSrc2={card.imageSrc2}
              imageSrc3={card.imageSrc3}
              title={card.title}
              features={card.features}
              buttonText={card.buttonText}
              buttonLink={card.buttonLink}
              disclaimer={card.disclaimer}
              disclaimerReadMoreOnclick={card.disclaimerReadMoreOnclick}
            />
          ))}
        </div>
      )}

      {activeTab === "protect" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mx-auto p-4 pb-0">
          {protectCardsData.map((card, index) => (
            <ProtectCard
              key={index}
              overlayText={card.overlayText}
              imageSrc={card.imageSrc}
              description={card.description}
              buttonText={isStep3Completed ? "Access Program" : "Full Details"}
              buttonLink={
                isStep3Completed
                  ? "https://www.simondixon.com/login"
                  : isUk
                  ? "https://www.bitcoinwealthbuilder.io/bwb "
                  : "https://www.simondixon.com/bwb"
              }
              disclaimer={card.disclaimer}
            />
          ))}
        </div>
      )}
    </div>
  );
};
